import React from "react";
import StoreIcon from "@mui/icons-material/Store";
// import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import LocalCarWashIcon from "@mui/icons-material/LocalCarWash";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import "./HeaderMenu.css";
import { checkInventory } from "../services/servicesv2";
import { closeLoading, notifyError, notifyLoading } from "src/assets/toastService";
// import { Link } from "react-router-dom";

interface HeaderMenuProps {
  Close: (data: boolean) => void;
}

const HeaderMenu: React.FC<HeaderMenuProps> = ({ Close }) => {
  // const ACCOUNTS_URL = process.env.REACT_APP_ACCOUNTS_API || "";
  const INVENTORY_URL = process.env.REACT_APP_INVENTORY_API || "";

  const openNewTabWithToken = (targetUrl: string, appName: string) => {
    const token = sessionStorage.getItem("jsonwebtoken");

    if (!token) {
      console.warn(`⚠️ Token not found in sessionStorage for ${appName}.`);
      alert("Please login first");
      return;
    }


    // Open the target app
    window.open(targetUrl, "_blank");
  };

  // const openNewTabAccountWithToken = () => {
  //   // openNewTabWithToken(ACCOUNTS_URL, "Accounts");
  //   Close(false);
  // };

  const openInventoryWithToken = () => {
    notifyLoading("Checking inventory...");
    checkInventory().then((response) => {
      console.log(response)
      if (response?.success === true && response?.handoff_token) {
        openNewTabWithToken(`${INVENTORY_URL}/?asses_token=${response?.handoff_token}`, "Inventory");
      }
    }).catch((error) => {
      console.error("❌ Error checking inventory:", error);
      notifyError("Error checking inventory. Please try again later.");
    }).finally(() => {
      closeLoading();
    })
    Close(false);
  };

  const menuIcons = (path: string, Icon: any, label: string) => {
    return (
      <div className='cursor-pointer hover:bg-gray-100 flex flex-col p-1 rounded-lg justify-center items-center' id='menu-icons'>
        <Icon className='feature-icon' />
        <p>{label}</p>
      </div>
    );
  };

  const dataIcons = (Icon: any, onClick: () => void, name: string) => (
    <div className='cursor-pointer hover:bg-gray-100 flex flex-col p-1 rounded-lg justify-center items-center' onClick={onClick} id='data-icons'>
      <Icon className='feature-icon' />
      <p>{name}</p>
    </div>
  );

  return (
    <div className='w-[440px] grid justify-center items-center p-1 text-black' id='header-menu-container'>
      <div className='w-full'>
        <p className='w-full flex justify-center items-center text-md font-semibold m-1' id='header-additional-title'>
          Additional Features
        </p>
        <div className='flex gap-4 w-full justify-center items-center'>
          {dataIcons(StoreIcon, openInventoryWithToken, "Inventory")}
          {/* {dataIcons(AccountBalanceWalletIcon, openNewTabAccountWithToken, "Accounts")} */}
        </div>
      </div>
      <div className='w-fit'>
        <p className='w-full flex justify-center items-center text-lg font-semibold m-1' id='header-products-title'>
          Our Company Products
        </p>
        <div className='grid grid-cols-4 gap-4 w-full'>
          {menuIcons("", LocalLaundryServiceIcon, "Laundry")}
          {menuIcons("", LocalCarWashIcon, "Car Wash")}
          {menuIcons("", DirectionsCarIcon, "Car Sales")}
          {menuIcons("", RestaurantIcon, "Restaurant")}
        </div>
      </div>
    </div>
  );
};

export default HeaderMenu;
